import { find, get, keyBy, mapValues, template, templateSettings } from "lodash";

export const getPageContent = (state, type) => {
  const {
    survey,
    survey: { branch, branches, pages },
    i18n: { locale }
  } = state;

  // Find the corresponding page based on its type for the current branch
  const branchObj = find(branches, { name: branch });
  const name = get(find(get(branchObj, 'pages', []), { type }), 'name');

  // Find page content based on these properties
  const page = find(pages, { name, locale });
  const content = get(page, "content", "");

  // TODO: add dynamic environment variables to the ones defined
  // const BRANCH = branch;
  // const LOCALE = locale;
  const environment = mapValues(keyBy(get(survey, 'environment', []), 'name'), 'value');

  try {
    templateSettings.interpolate = /{{([\s\S]+?)}}/g;
    const compiled = template(content);
    return compiled(environment);
  } catch (error) {
    console.log(error);
  }
};

export default getPageContent;
